import React, {Component, Children, createElement} from 'react';
import PropTypes from 'prop-types';
//添加和去除样式
const changeClassName = (originCls, addCls, type = 'add') => {
    if(!addCls){
        return originCls;
    }
    if(!originCls){
        return type == 'add' ? addCls : originCls;
    }
    originCls = originCls.split(' ');
    if(type == 'add'){
        originCls.push(addCls);
    }
    else if(type == 'remove'){
        originCls = originCls.filter(function(item){return item != addCls});
    }
    return originCls.join(' ');
}
class TabHeader extends Component{
    constructor(props) {
        super(props);
        this.state = {};
        this.clk = this.clk.bind(this);
    }
    clk(index, func){
        return (e) => {
            func && func(e);
            this.context.changeState('index', index);
        }
    }
    render(){
        let self = this;
        let {children, className, selectCls, tag} = self.props;
        let {index} = self.context;
        let newChilds = Children.map(children, (item, n) => {
            let cls = item.props.className;
            cls = changeClassName(cls, selectCls, n == index ? 'add' : 'remove');
            return createElement(item.type, {...item.props, className : cls, onClick : self.clk(n, item.props.onClick)}, item.props.children);
        })
        let newNode = createElement(tag, {className}, newChilds);
        return newNode
    }
}
TabHeader.propTypes = {
    className : PropTypes.string,
    tag : PropTypes.string,
    selectCls : PropTypes.string.isRequired
}
TabHeader.defaultProps = {
    tag : 'div'
}
TabHeader.contextTypes = {
    index : PropTypes.number,
    changeState : PropTypes.func
}
export default TabHeader;


// WEBPACK FOOTER //
// ./client/component/tab/header.js